/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { setResources, setResourceNS, resetEntityFormInitialState } from './policyEntity/entityActionCreator';
import { setDataPlatformActions } from './roleActionCreator';
import { showErrorAction } from '../error/errorActionCreator';
import { getResourceNSApi, getActionsApi, getResourceTypesApi } from '../../services/policy';
import interpolateString from '../../utility/stringInterpolation';
import { DATA_PLATFORM_NAMESPACE } from '../../shared/PolicyDialog/constants';
import { POLICY, FETCH_ACTIONS_ERROR } from './constants';

export function resetPolicyDialog(dispatch: Function) {
  dispatch(setResources([], {}));
  dispatch(setResourceNS([]));
  dispatch(resetEntityFormInitialState());
}

export async function fetchDataPlatformActions(dispatch: Function) {
  let dataPlatformActions = [];
  let policyResourceTypes:any = [];
  let errorMessage = { message: '' };

  try {
    const resourceNamespaceRes = await getResourceNSApi();

    const dpNamespace = resourceNamespaceRes.find((res: any) => res.name === DATA_PLATFORM_NAMESPACE);

    if (dpNamespace) {
      [dataPlatformActions, policyResourceTypes] = await Promise.all([
        getActionsApi({ namespaceId: dpNamespace.id }),
        getResourceTypesApi({ namespaceId: dpNamespace.id, category: POLICY })
      ]);
    }
  } catch (error: any) {
    errorMessage = {
      message: interpolateString([error.response.data.message], FETCH_ACTIONS_ERROR)
    };
  } finally {
    dispatch(setDataPlatformActions(dataPlatformActions, policyResourceTypes));
    dispatch(showErrorAction(errorMessage));
  }
}
